export default __webpack_public_path__ + "static/media/dog2.518b9959.png";